import React from 'react';
import styled from 'styled-components';

// STYLE-COMPONENTS
// ===================================
const PublicLayout = styled.div`
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: #fff;
`;

// EXPORT
// ===================================
export default ({ children, currentUser }) => (
  <PublicLayout>
    <React.Fragment>
      <div>{children}</div>
    </React.Fragment>
  </PublicLayout>
);



// WEBPACK FOOTER //
// ./src/components/layout/DashboardLayout/index.js